import { clsx, type ClassValue } from 'clsx';

export const isHttp = (str: string) => /^(http|https):\/\//.test(str);

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
